module.exports = __webpack_public_path__ + "static/img/1.cc73a08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sections/1.svg
// module id = e3Bw
// module chunks = 0